import { render, staticRenderFns } from "./dongtai_0.vue?vue&type=template&id=124d4fdc&scoped=true&"
import script from "./dongtai_0.vue?vue&type=script&lang=js&"
export * from "./dongtai_0.vue?vue&type=script&lang=js&"
import style0 from "./dongtai_0.vue?vue&type=style&index=0&id=124d4fdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124d4fdc",
  null
  
)

export default component.exports